import { useDrop } from 'react-dnd';
import { InspectorDetails } from '../../models/inspector';
import { WorkOrder } from '../../models/workOrder';
import { useState } from 'react';
import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Pagination,
  Popover,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import dayjs from 'dayjs';
import { workOrdersApiKeyStore } from '../../api/workorders-api-key-store';
import { useSaveData } from '../../hooks/useSaveData';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';
import { LoadingIndicator } from '../../components/loading-indicator.component';
import BulkScheduleCalenderComponent from '../scheduling/bulk-schedule-calender.component';
import { Icons } from '../../assets/icons';
import { useSnackbar } from '../../hooks/use-snackbar.hook';

interface InspectorsListProps {
  inspectionType: string;
  inspectors: InspectorDetails[];
  setOpenDialog: (value: boolean, inspectorType: string, inspections: any, inspector: any) => void;
  setSelectedWorkOrder: React.Dispatch<React.SetStateAction<WorkOrder[]>>;
  setSelectedInspector: React.Dispatch<React.SetStateAction<InspectorDetails | null>>;
  setInspectionType: (inspectionType: any) => void;
}

const InspectorsList = ({
  inspectors,
  inspectionType,
  setOpenDialog,
  setSelectedInspector,
  setSelectedWorkOrder,
  setInspectionType
}: InspectorsListProps) => {
  if (!inspectors || inspectors.length === 0) return <p style={{ textAlign: 'center' }}>No inspectors available.</p>;

  const handleChange = (event: any) => {
    setInspectionType(event.target.value);
  };

  const handleOpenDialog = (value: any, inspeType: any, inspectionData: any, inspectorData: any) => {
    setOpenDialog(value, inspeType, inspectionData, inspectorData);
  }

  return (
    <div className="flex flex-col gap-4 p-4" style={{ width: '100%' }}>
      <h3 style={{ fontSize: '20px', fontWeight: 'bold', padding: 0, marginBottom: '10px' }}>INSPECTORS</h3>
      <span className="btnInfoOuterBlock">
        {' '}
        <Typography
          style={{
            position: 'relative',
            cursor: 'pointer',
            color: '#007bff',

            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <Tooltip title="Drop the work order under Inspections here to assign it.">
            <span className="btn btn-sm btn-dark btnInfoBlock" style={{}}></span>
          </Tooltip>
        </Typography>
      </span>
      <div style={{ paddingBottom: '5px' }}>
        <FormControl>
          <RadioGroup
            row
            name="inspection-type"
            value={inspectionType}
            onChange={handleChange}
          >
            <FormControlLabel
              value="primaryInspection"
              control={<Radio size='small' />}
              label="Primary Inspector"
            />
            <FormControlLabel
              value="secondaryInspection"
              control={<Radio size='small' />}
              label="Secondary Inspector"
            />
          </RadioGroup>
        </FormControl>
      </div>
      {inspectors.map((inspector) => (
        <DroppableInspector
          key={inspector.userID}
          inspector={inspector}
          inspectionType={inspectionType}
          setOpenDialog={handleOpenDialog}
          setSelectedInspector={setSelectedInspector}
          setSelectedWorkOrder={setSelectedWorkOrder}
        />
      ))}
    </div>
  );
};

const DroppableInspector = ({
  inspector,
  inspectionType,
  setOpenDialog,
  setSelectedInspector,
  setSelectedWorkOrder,
}: {
  inspector: any;
  inspectionType: string;
  setOpenDialog: (value: boolean, inspectorType: string, inspections: any, inspector: any) => void;
  setSelectedInspector: (inspector: any) => void;
  setSelectedWorkOrder: (workOrder: WorkOrder[]) => void;
}) => {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: 'inspection',
      drop: (item: { inspections: WorkOrder[] }) => {
        setOpenDialog(true, inspectionType, item.inspections, inspector);
        setSelectedWorkOrder(item.inspections);
        setSelectedInspector(inspector);
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }),
    [inspectionType, inspector]
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [inspectorID, setInspectorID] = useState<any>();
  const [calendarDialog, setCalendarDialog] = useState<any>();

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleInspectorCalendar = (inspectorID: any) => {
    setInspectorID(inspectorID);
    setCalendarDialog(true);
  };
  const formatMinutes = (minutes: any) => {
  if (!minutes || minutes === 0) return "0 mins";

  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;

  const hrLabel = hrs === 1 ? "hr" : "hrs";
  const minLabel = mins === 1 ? "min" : "mins";

  if (hrs > 0 && mins > 0) return `${hrs} ${hrLabel} ${mins} ${minLabel}`;
  if (hrs > 0) return `${hrs} ${hrLabel}`;
  return `${mins} ${minLabel}`;
  };
  return (
    <div
      ref={drop}
      style={{
        background: isOver ? 'white' : '#f0f8ff',
        marginBottom: 10,
        padding: '8px 10px',
        position: 'relative',
        border: isOver ? '1px dashed #000' : '1px solid transparent',
      }}
      className="inspectorBlock bg-white shadow-md rounded-lg p-4 border border-gray-300"
    >
      <h3 className="text-lg text-gray-600" style={{ display: 'flex', justifyContent: 'space-between' }}>
        {inspector?.userName}{' '}
        <Typography
          variant="body1"
          style={{
            position: 'absolute',
            top: '8px',
            right: '95px',
            fontSize: '12px',
            padding: '0px 6px',
          }}
        >
          {/* <strong>Calendar:</strong>{' '} */}
          <IconButton aria-label="move" onClick={() => handleInspectorCalendar(inspector?.userID)}>
            <Tooltip title={<Typography variant="body1">Calendar</Typography>}>
              <img src={Icons.IconCalendar} alt="Schedule" />
            </Tooltip>
          </IconButton>
        </Typography>
      </h3>
      <div
        style={{
          display: 'flex',
          alignItems: 'left',
          gap: '16px',
          flexDirection: 'row',
          justifyContent: 'flex-start',
        }}
      >
        <div
        style={{
          display: 'flex',
          alignItems: 'left',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          marginRight: '40px',
        }}
        >
          <p className="text-gray-600">
            <small>Primary Inspection Count: </small>{' '}
            <span style={{ color: 'green', fontWeight: 'bold' }}>{inspector?.scheduledInspectionCount}</span>
          </p>
          <p className="text-gray-600">
            <small>Secondary Inspection Count: </small>{' '}
            <span style={{ color: 'green', fontWeight: 'bold' }}>{inspector?.secondaryInspectionCount}</span>
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'left',
            flexDirection: 'column',
            justifyContent: 'flex-start',
          }}
        >
          
          <p className="text-gray-600">
            <small>Primary Inspector Total Time: </small>{' '}
            <span style={{ color: 'green', fontWeight: 'bold' }}>{formatMinutes(inspector?.primaryInspectorExpectedTime)}</span>
          </p>
          <p className="text-gray-600">
            <small>Secondary Inspector Total Time: </small>{' '}
            <span style={{ color: 'green', fontWeight: 'bold' }}>{formatMinutes(inspector?.secondaryInspectorExpectedTime)}</span>
          </p>
          <p className="text-gray-600">
            <small>Combined Total Time: </small>{' '}
            <span style={{ color: 'green', fontWeight: 'bold' }}>{formatMinutes(inspector?.totalExpectedTime)}</span>
          </p>
        </div>
      </div>
      <button
        onClick={handlePopoverOpen}
        className="btn btn-sm btn-dark"
        style={{
          position: 'absolute',
          top: '15px',
          right: '10px',
          fontSize: '12px',
          padding: '0px 6px',
          cursor: 'pointer',
        }}
      >
        More Info
      </button>
      <Popover
        className="popOverOuterWrap inspectorPopover"
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <div style={{ padding: '10px' }} className="popOverInnererWrap">
          <Typography variant="body1">
            <small>Market Area: </small> {inspector?.userMarketAreas || ''}
          </Typography>
          <Typography variant="body1">
            <small>Skill Sets: </small> {inspector?.userSkillsets || ''}
          </Typography>
          <Typography variant="body1">
            <small>Equipments: </small> {inspector?.userEquipments || ''}
          </Typography>
        </div>
      </Popover>
      {calendarDialog && (
        <BulkScheduleCalenderComponent
          open={calendarDialog}
          inspectorID={inspectorID}
          onClosed={() => setCalendarDialog(false)}
        />
      )}
    </div>
  );
};

const Inspectors = ({ inspectors, handleInspectorFilterClick, passInspectionType, handleInspectionsFilterClick }: any) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState<WorkOrder[]>([]);
  const [selectedInspector, setSelectedInspector] = useState<InspectorDetails | null>(null);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState({ severity: 'success', messageInfo: '' });
  const [pendingErrorRules, setPendingErrorRoles] = useState([]);
  const [workOrderForWarnings, setWorkOrderForWarnings] = useState([]);
  const [openDialogForDate, setOpenDialogForDate] = useState(false);
  const ishavePermission = useAuthorize([UserPermissionName?.OVERRIDE]);

  const { showSnackbar } = useSnackbar();

  const [inspectionType, setInspectionType] = useState<any>("primaryInspection");

  const { isLoading, mutateAsync } = useSaveData<any>(workOrdersApiKeyStore.bulkSchedule());

  const { isLoading: sheduleRuleLoading, mutateAsync: sheduleRuleCheck } = useSaveData<any>(
    workOrdersApiKeyStore.validateWorkOrderSheduleRules()
  );

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const closeValidationDialog = () => {
    setOpenDialogForDate(false);
  };

  const handleSubmitConfirm = async () => {
    setOpenDialog(false);
    if (selectedWorkOrder?.length === 0) {
      setOpen(true);
      setPendingErrorRoles([]);
      setMessage({ severity: 'error', messageInfo: 'Please select a work order' });
      return;
    }

    if (inspectionType === "secondaryInspection" && isInspectorPresent(selectedWorkOrder, selectedInspector?.userID)) {
      setOpen(true);
      setPendingErrorRoles([]);
      setMessage({ severity: 'error', messageInfo: 'An inspector selected as the Primary Inspector cannot also be selected as the Secondary Inspector.' });
      return;
    }
    if (inspectionType === "primaryInspection" && isSecondaryInspectorPresent(selectedWorkOrder, selectedInspector?.userID)) {
      setOpen(true);
      setPendingErrorRoles([]);
      setMessage({ severity: 'error', messageInfo: 'An inspector selected as the Secondary Inspector cannot also be selected as the Primary Inspector.' });
      return;
    }
    const data = {
      workOrders: selectedWorkOrder,
      keepScheduledDateasOriginal: true,
      ...(inspectionType === "primaryInspection"
        ?
        {
          inspectorID: selectedInspector?.userID,
        } : {
          inspectorID: null,
          secondaryInspectorID: selectedInspector?.userID,
          remoteInspection: true,
        }),
    };
    handleSubmit(data);
  };

  const handleDirectApiCall = async (data: any) => {
    await mutateAsync({
      data: {
        ...data,
        scheduledDate: '',
        workOrders: data.workOrders ? data.workOrders.map((p: any) => p.workOrderID) : [],
        ScheduleFromArea: 'Schedule Balancing',
      },
    });
    setMessage({ severity: 'success', messageInfo: 'Bulk scheduling completed successfully!' });
    setOpen(true);
    setWorkOrderForWarnings([]);
    setPendingErrorRoles([]);
    setOpenDialogForDate(false);
    handleInspectionsFilterClick();
    handleInspectorFilterClick([]);

  };

  const addPendingRule = (workOrder: any, pendingRulesMessages: any, message: any) => {
    const existingEntry = pendingRulesMessages?.find((ruleMessage: any) => ruleMessage.workOrderName === workOrder);

    if (existingEntry) {
      // If it exists, add the message to its pendingRules
      existingEntry.pendingRules.push(message);
    } else {
      // If it does not exist, add a new entry with the message
      pendingRulesMessages.push({
        workOrderName: workOrder,
        pendingRules: [message],
      });
    }
  };

  const processWarnings = (workOrderForWarnings: any, pendingRulesMessages: any, message: any) => {
    setWorkOrderForWarnings(workOrderForWarnings);

    workOrderForWarnings.forEach((workOrder: any) => {
      addPendingRule(workOrder, pendingRulesMessages, message);
    });

    setPendingErrorRoles(pendingRulesMessages);
    setOpenDialogForDate(true);
  };

  const handleSubmit = async (data: any) => {
    const scheduleMessage = 'The schedule time is greater than cut off time';

    // const filteredData = data?.workOrders?.filter((item: any) => item.workOrderStatus !== "Scheduled");

    const rulePayload = {
      workOrderInfos: data?.workOrders?.map((item: any) => ({
        workOrderID: item.workOrderID,
        workOrderNumber: item.workOrderNumber,
        scheduledDate:
          item?.workOrderStatus == "Ready" ? item?.proposedScheduledDate :
            (item?.workOrderStatus == "Scheduled" && !item?.requestedRescheduledDate) ? item?.scheduledDate :
              (item?.workOrderStatus == "Scheduled" && item?.requestedRescheduledDate) ? item?.proposedScheduledDate
                : dayjs(data?.scheduledDate)?.format('MM/DD/YYYY'),
      }))
    };

    const ruleResponse: any = await sheduleRuleCheck({ data: rulePayload });

    const pendingRuleResponse = ruleResponse?.data?.map((item: any) => ({
      workOrderName: item.workOrderNumber,
      pendingRules: item.pendingRules,
      preReqWorkOrders: item?.preReqWorkOrders
    }));

    const pendingRulesMessages = pendingRuleResponse;

    if (!selectedInspector) {
      setOpen(true);
      setPendingErrorRoles([]);
      setMessage({ severity: 'error', messageInfo: 'Please select inspector' });
    } else if (data?.keepScheduledDateasOriginal) {
      const proposedScheduleDateWarnings: string[] = [];
      const scheduleDateWarnings: string[] = [];
      const requestScheduleDateWarnings: string[] = [];

      data?.workOrders?.forEach((workOrder: any) => {
        const { workOrderStatus, proposedScheduledDate, scheduledDate, requestedRescheduledDate, workOrderNumber } =
          workOrder;

        // Check for past proposed schedule date
        if (workOrderStatus === 'Ready' && dayjs(proposedScheduledDate).isBefore(dayjs().startOf('day'))) {
          proposedScheduleDateWarnings.push(workOrderNumber);
        }

        // Check for scheduled work orders
        if (workOrderStatus === 'Scheduled') {
          if (!requestedRescheduledDate && dayjs(scheduledDate).isBefore(dayjs().startOf('day'))) {
            scheduleDateWarnings.push(workOrderNumber);
          } else if (requestedRescheduledDate && dayjs(requestedRescheduledDate).isBefore(dayjs().startOf('day'))) {
            requestScheduleDateWarnings.push(workOrderNumber);
          }
        }
      });

      const showErrorMessage = (workOrderNumbers: string[], message: string) => {
        setOpen(true);
        setPendingErrorRoles([]);
        setMessage({
          severity: 'error',
          messageInfo: `Selected work order ${workOrderNumbers.join(', ')} ${message}`,
        });
      };

      if (
        proposedScheduleDateWarnings?.length > 0 ||
        scheduleDateWarnings?.length > 0 ||
        requestScheduleDateWarnings?.length > 0
      ) {
        if (proposedScheduleDateWarnings.length > 0) {
          showErrorMessage(proposedScheduleDateWarnings, 'have past proposed schedule date');
        } else if (scheduleDateWarnings.length > 0) {
          showErrorMessage(scheduleDateWarnings, 'have past schedule date');
        } else if (requestScheduleDateWarnings.length > 0) {
          showErrorMessage(requestScheduleDateWarnings, 'have past requested reschedule date');
        }
      } else {
        // When `keepScheduledDateasOriginal` is true
        const workOrderForWarnings = data?.workOrders
          ?.filter((order: any) => {
            const scheduledDate = dayjs(order.scheduledDate);
            const cutOffTime = order.cutOffTime ? dayjs(order.cutOffTime, 'hh:mm A') : null;
            const proposedScheduledDate = order.proposedScheduledDate ? dayjs(order.proposedScheduledDate) : null;
            const now = dayjs().startOf('minute');

            if (order.workOrderStatus === 'Scheduled' && scheduledDate.isSame(dayjs(), 'day')) {
              return cutOffTime && cutOffTime.isBefore(dayjs());
            } else if (
              order.workOrderStatus === 'Ready' &&
              proposedScheduledDate &&
              proposedScheduledDate.isSame(dayjs(), 'day')
            ) {
              return cutOffTime && cutOffTime.isBefore(dayjs());
            }
            return false;
          })
          .map((order: any) => order.workOrderNumber);

        if (workOrderForWarnings?.length > 0 || pendingRulesMessages?.length > 0) {
          if (workOrderForWarnings?.length > 0) {
            processWarnings(workOrderForWarnings, pendingRulesMessages, scheduleMessage);
          } else {
            setWorkOrderForWarnings([]);
            setPendingErrorRoles(pendingRulesMessages);
            setOpenDialogForDate(true);
          }
        } else {
          handleDirectApiCall(data);
        }
      }
    } else {
      if (pendingRulesMessages?.length > 0) {
        setWorkOrderForWarnings([]);
        setPendingErrorRoles(pendingRulesMessages);
        setOpenDialogForDate(true);
      } else {
        handleDirectApiCall(data);
      }
    }
  };

  const handleCloseSnakbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  //   pagination
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);

  const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
  };

  const handleItemsPerPageChange = (event: any) => {
    setItemsPerPage(event.target.value as number);
    setPage(1);
  };

  const validInspectors = Array.isArray(inspectors) ? inspectors : [];

  const startIndex = (page - 1) * itemsPerPage;
  const paginatedInspections = validInspectors.slice(startIndex, startIndex + itemsPerPage);

  const isInspectorPresent = (data: any, inspectorId: any) => {
    return data?.some((item: any) => item?.inspectorID === inspectorId);
  };
  const isSecondaryInspectorPresent = (data: any, secondaryinspectorId: any) => {
    return data?.some((item: any) => item?.secondaryInspectorID === secondaryinspectorId);
  };
  const handleSumbitConfirm = async () => {
    const data = {
      workOrders: selectedWorkOrder,
      keepScheduledDateasOriginal: true,
      ...(inspectionType === "primaryInspection"
        ?
        {
          inspectorID: selectedInspector?.userID,
        } : {
          inspectorID: null,
          secondaryInspectorID: selectedInspector?.userID,
          remoteInspection: true,
        }),
    };
    handleDirectApiCall(data);
    setOpenDialogForDate(false);
  };

  const handleInspectionType = (typeValue: any) => {
    setInspectionType(typeValue);
    passInspectionType(typeValue);
  }

  const checkSkillsetMatch = (data1: any[], data2: any): boolean => {
    if (!data1?.length || !data2?.userSkillsets) return false;

    const userSkillsetsArray = data2?.userSkillsets
      ?.split(",")
      ?.map((skill: string) => skill?.trim());

    return data1?.every((item) => {
      if (!item.serviceSkillsets) return false;

      const serviceSkillsArray = item?.serviceSkillsets
        .split(",")
        .map((skill: string) => skill?.trim());

      return serviceSkillsArray?.some((skill: string) =>
        userSkillsetsArray?.includes(skill)
      );
    });
  };

  const checkInspector = (data: any) => {
    return data?.some(
      (item: any) => item?.inspectorID === null || item?.inspectorID === 0
    );
  };

  const getInvalidRemoteInspectionWorkOrders = (data: any) => {
    const invalidWorkOrders = Array.from(
      new Set(
        data
          ?.filter(
            (item: any) =>
              item?.remoteInspection === false || item?.remoteInspection === null
          )
          ?.map((item: any) => item?.workOrderNumber)
      )
    );

    return invalidWorkOrders.join(", ");
  };

  const openConfirmDialog = (value: any, inspType: string, inspectionData: any, inspectorData: any) => {
    if (inspType === "primaryInspection" && !checkSkillsetMatch(inspectionData, inspectorData)) {
      showSnackbar(`The Primary Inspector does not have any matching skill set(s) for the selected inspection.`, 'warning');
      return;
    }

    const invalidWorkOrders = getInvalidRemoteInspectionWorkOrders(inspectionData);
    if (inspType === "secondaryInspection" && invalidWorkOrders) {
      showSnackbar(`Cannot assign a Secondary Inspector because Remote Inspection is not enabled for Work Order(s): ${invalidWorkOrders}.`, 'warning');
      return;
    }

    if (inspType === "secondaryInspection" && checkInspector(inspectionData)) {
      showSnackbar(`Primary Inspector must be scheduled before assigning a Secondary Inspector.`, 'warning');
      return;
    }
    setOpenDialog(value);
  }

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <div>
      {(isLoading || sheduleRuleLoading) && <LoadingIndicator isLoading={isLoading || sheduleRuleLoading} />}
      <InspectorsList
        inspectors={paginatedInspections}
        inspectionType={inspectionType}
        setOpenDialog={openConfirmDialog}
        setSelectedInspector={setSelectedInspector}
        setSelectedWorkOrder={setSelectedWorkOrder}
        setInspectionType={handleInspectionType}
      />
      {validInspectors.length > 0 && (
        <Grid
          padding={10}
          style={{
            padding: '20px 0px 15px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Pagination
            count={Math.ceil(validInspectors.length / itemsPerPage)}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
          <FormControl className="pagingperSelect" variant="outlined">
            <Select
              labelId="items-per-page-label"
              id="items-per-page-select"
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={30}>30</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
            <span>items per page</span>
          </FormControl>
        </Grid>
      )}

      <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={handleCloseSnakbar}
      >
        {message.severity === 'success' ? (
          <Alert severity="success" variant="filled" sx={{ width: '100%' }} onClose={handleCloseSnakbar}>
            {!message.messageInfo ? 'Bulk scheduling completed successfully!' : message?.messageInfo}
          </Alert>
        ) : (
          <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={handleCloseSnakbar}>
            {pendingErrorRules?.length > 0 ? (
              <ul>
                {pendingErrorRules.map((errorRule: any, index: number) => (
                  <li key={index}>
                    {errorRule.workOrderName}: {errorRule.pendingRules.join(', ')}
                  </li>
                ))}
              </ul>
            ) : !message.messageInfo ? (
              ''
            ) : (
              message?.messageInfo
            )}
          </Alert>
        )}
      </Snackbar>
      {openDialog && (
        <Dialog
          open={openDialog}
          className="modalpopup"
          title={'CONFIRM STATUS'}
        // onClose={closeDialog}
        >
          <div>
            <div style={{ padding: '25px 50px', textAlign: 'center' }}>
              <div>
                Do you want to add <>{selectedWorkOrder?.length > 1 ? 'these inspections' : 'this inspection'}</>{' '}
                <strong>{selectedWorkOrder?.map((wo) => wo.workOrderNumber)?.join(', ')}</strong> to{' '}
                <strong>{selectedInspector?.userName}</strong> as a {inspectionType == "primaryInspection" ? "primary inspector" : "secondary inspector"}?
              </div>
            </div>
          </div>
          <DialogActionsBar>
            {isReadOnlyPermission && (
              <Button style={{ maxWidth: '140px' }} size='small' type="button" variant="outlined" onClick={() => setOpenDialog(false)}>
                Cancel
              </Button>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }} className="  ">
              <button
                className="btn btn-sm btn-primary btn-lightGrey"
                style={{
                  backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                  color: isReadOnlyPermission ? 'black' : '#fff',
                  cursor: 'pointer', padding: 2, marginRight: 6
                }}
                disabled={isReadOnlyPermission}
                onClick={closeDialog}
                autoFocus
              >
                No
              </button>

              <button
                className="btn btn-sm btn-primary  btn-delete"
                style={{
                  backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                  color: isReadOnlyPermission ? 'black' : '#fff',
                  cursor: 'pointer', padding: 2
                }}
                disabled={isReadOnlyPermission}
                type="button"
                onClick={handleSubmitConfirm}
              >
                Yes
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
      {openDialogForDate && (
        <Dialog
          open={openDialogForDate}
          className="modalpopup"
          title={'CONFIRM STATUS'}
        // onClose={closeDialog}
        >
          <div>
            <div style={{ padding: '25px 50px' }}>
              <div>
                <h4>Please see the below validations</h4>
                <br></br>
                {pendingErrorRules?.length > 0 ? (
                  <>
                    <ul>
                      {pendingErrorRules.map((data: any, index: number) => (
                        <li key={index}>
                          <ul>
                            <span style={{ color: 'orangered' }}>{data?.workOrderName}</span>
                            {data?.pendingRules?.map((errorRule: any) => (
                              <>
                                <li style={{ marginLeft: '25px' }} key={errorRule}>
                                  <span>{errorRule}</span>
                                </li>
                                {errorRule.includes("pre-requisite") && data?.preReqWorkOrders?.length > 0 && (
                                  <dl style={{ paddingLeft: 25 }}>
                                    <dt>Pending Work Orders:</dt>
                                    {data?.preReqWorkOrders?.map((data: any) => <dd key={data}>- {data}</dd>)}
                                  </dl>
                                )}
                              </>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                    <br></br>
                    <div>
                      {ishavePermission ? (
                        <h5>
                          You have the permission to schedule without completing the validations. Are you sure you want
                          to continue?
                        </h5>
                      ) : (
                        <h5>You can not schedule without completing the validations.</h5>
                      )}
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
              <LoadingIndicator isLoading={isLoading} />
            </div>
          </div>
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button
                style={{ cursor: 'pointer' }}
                className="btn btn-sm btn-default btn-lightGrey"
                onClick={closeValidationDialog}
                autoFocus
              >
                Cancel
              </button>
              {ishavePermission && (
                <button
                  className="btn btn-sm btn-primary  btn-delete"
                  type="button"
                  onClick={handleSumbitConfirm}
                  disabled={isLoading}
                  style={{ cursor: 'pointer' }}
                >
                  Confirm
                </button>
              )}
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};

export default Inspectors;
